const goaItinerary = {
  slug:"goa-quick-break",
  title: "Goa Beach Break",
  duration: "3 days",
  location: "Goa, India",
  difficulty: "Easy",
  priceRange: "$$ (Mid-range)",
  bestTime: "November to February",
  description:
    "A short and relaxing getaway with beaches, nightlife, water sports, and Portuguese heritage.",

  highlights: [
    "North Goa beaches",
    "Water sports activities",
    "Nightlife & beach clubs",
    "Portuguese churches"
  ],

  image:
    "https://images.unsplash.com/photo-1507525428034-b723cf961d3e",

  days: [
    {
      day: 1,
      title: "Arrival & North Goa",
      places: [
        "Goa International Airport",
        "Calangute Beach",
        "Baga Beach"
      ],
      activities: [
        "Arrival in Goa",
        "Visit Calangute & Baga Beach",
        "Water sports activities",
        "Evening beachside dinner"
      ],
      accommodation: "Beach resort",
      meals: "Dinner included"
    },
    {
      day: 2,
      title: "South Goa & Culture",
      places: [
        "Basilica of Bom Jesus, Old Goa",
        "Colva Beach",
        "Mandovi River",
        "Fort Aguada",
        "Anjuna Beach"
      ],
      activities: [
        "Visit Basilica of Bom Jesus",
        "Explore Colva Beach",
        "River cruise on Mandovi",
        "Nightlife in North Goa"
      ],
      accommodation: "Beach resort",
      meals: "Breakfast included"
    },
    {
      day: 3,
      title: "Departure",
      places: [
        "Dudhsagar Waterfalls",
        "Panaji Municipal Market",
        "Goa International Airport"
      ],
      activities: [
        "Leisure morning",
        "Shopping at local markets",
        "Departure"
      ],
      accommodation: "N/A",
      meals: "Breakfast included"
    }
  ],

  inclusions: [
    "2 nights accommodation",
    "Daily breakfast",
    "Airport transfers",
    "Sightseeing"
  ],

  exclusions: [
    "Flights",
    "Personal expenses",
    "Water sports charges"
  ],

  tips: [
    "Carry sunscreen",
    "Book clubs in advance",
    "Avoid peak sun hours"
  ],

  budget: {
    accommodation: "₹3,000–5,000/night",
    food: "₹800–1,200/day",
    activities: "₹1,500–3,000",
    total: "₹12,000–18,000 per person"
  }
};

export default goaItinerary;
